import type { SVGProps } from "react";
export interface Medal01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Medal01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Medal01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.38.875c.705 0 1.357.348 1.75.917l.15.258.718 1.435.72-1.435.152-.258a2.13 2.13 0 0 1 1.748-.917h3.572a1.625 1.625 0 0 1 1.455 2.351L16.53 9.453l-.057.101a1.126 1.126 0 0 1-1.956-1.107l2.662-5.322h-2.483L13.257 6l.786 1.574a1.125 1.125 0 1 1-2.012 1.006L9.303 3.125H6.82l2.663 5.323A1.125 1.125 0 0 1 7.47 9.455L4.355 3.228A1.626 1.626 0 0 1 5.808.875z"
      />
      <path
        fill={color}
        d="M17.875 15a5.875 5.875 0 1 0-11.75 0 5.875 5.875 0 0 0 11.75 0m-6.969-4.063a1.346 1.346 0 0 1 2.189 0l.102.171.699 1.377 1.576.225c1.065.15 1.58 1.489.737 2.289l-1.124 1.065.266 1.494c.203 1.155-1.012 1.892-1.936 1.42L12 18.25l-1.415.726c-.924.473-2.138-.264-1.935-1.419l.264-1.495-1.121-1.064c-.844-.8-.33-2.138.735-2.29l1.575-.224.7-1.377.104-.171Zm.94 3.09a1.13 1.13 0 0 1-.848.606l-.282.04.184.174c.274.26.4.64.334 1.012l-.05.283.304-.154.123-.054c.293-.108.62-.09.9.054l.305.155-.05-.284c-.065-.372.06-.752.335-1.012l.183-.175-.283-.04a1.13 1.13 0 0 1-.847-.604L12 13.722zm8.279.974a8.125 8.125 0 1 1-16.25-.002 8.125 8.125 0 0 1 16.25.002"
      />
    </svg>
  );
}
